// extracted by mini-css-extract-plugin
export var quantityInput = "_il-0";